Px.Editor.MaskGalleryStore = class MaskGalleryStore extends Px.Editor.BaseThemeGalleryStore {};
Px.Editor.MaskGalleryStore.GALLERY_ID = 'masks';
